import { FC, useId } from 'react'

import { Ellipsis, Relative, Text, VStack, Widget } from '@revolut-internal/ui-kit'

import { formatNumber } from 'utils/formatNumber'

import { EllipsisText } from '../EllipsisText'

import { TILE_HEIGHT, TILE_WIDTH } from './consts'

const getDescriptionId = (id: string) => `description-${id}`

type MainValueItem = {
  value: string | number
  unit: string
}

type DataTileProps = {
  header: string
  mainValue: MainValueItem | MainValueItem[]
  extraValue?: string
  hasBreach?: boolean
}

const renderMainValue = ({ value, unit }: MainValueItem) => (
  <Text key={`${value}-${unit}`}>
    {formatNumber(value)} <Text variant="body2">{unit}</Text>{' '}
  </Text>
)

export const DataTile: FC<DataTileProps> = ({
  header,
  mainValue,
  extraValue,
  hasBreach = false,
}) => {
  const color = hasBreach ? 'warning' : undefined

  const id = useId()

  return (
    <Widget
      use={Relative}
      padding="s-16"
      width={TILE_WIDTH}
      height={TILE_HEIGHT}
      role="group"
      aria-label={`${header} data tile`}
      aria-describedby={getDescriptionId(id)}
    >
      <VStack>
        <Text variant="body2" color="grey-tone-50">
          {header}
        </Text>
        <EllipsisText variant="heading2" color={color} id={getDescriptionId(id)}>
          {Array.isArray(mainValue)
            ? mainValue.map(renderMainValue)
            : renderMainValue(mainValue)}
        </EllipsisText>
        {extraValue && (
          <Ellipsis tooltip="auto">
            <Text variant="body2" color={color}>
              {extraValue}
            </Text>
          </Ellipsis>
        )}
      </VStack>
    </Widget>
  )
}
